<template>
    <div class="home">
        <div class="top">               
            <div class="product-list">
                <div class="list-element" v-for="(element, ind) in ulist" :key="ind" @click="undway_apply(element.orderId, element.orderState)">                    
                    <h2 class="element-title">
                        <img :src="element.logo" alt="">
                        <span v-text="element.name"></span>
                    </h2>
                    <div class="info">
                        <div class="other-info">
                            <div class="oi-left">
                                <div class="left-text">
                                    <span class="left" v-text="element.amountMsg"></span>
                                    <br>
                                    <span class="right strong" v-text="`  ₹ ${element.amount}`"></span>
                                </div>
                                <div class="other-text">
                                    <span class="left">Interest:</span>                                    
                                    <span class="right" v-text="element.interest"></span>
                                </div>                                
                            </div>                            
                        </div>
                        <div class="oi-right">
                            <a @click="undway_apply(element.orderId, element.orderState)"  href="javascript:void(0);" class="btn-apply active" v-text="element.fullButtonName"></a>
                        </div>                        
                    </div>
                </div>
                <div class="list-element" v-for="(element, ind) in list" :key="ind" @click="before_apply(element)">
                    <div class="list-element-cover" @click.stop="showDialog(element.orderNum)" v-show="element.productStatus == 0">
                        <div class="list-element-cover-container">
                            <img src="../../../assets/images/callback/cooper.png" v-if="element.orderNum == 2" alt="">
                            <img src="../../../assets/images/callback/siliver.png" v-else-if="element.orderNum == 3" alt="">
                            <img src="../../../assets/images/callback/gold.png" v-else-if="element.orderNum >= 4" alt="">                            
                        </div>                        
                    </div>                    
                    <div class="info">
                        <div class="other-info">
                            <div class="oi-left">
                                <div class="left-text">
                                    <span class="left">Max Amount:</span>
                                    <br>
                                    <span class="right strong" v-text="`  ₹ ${element.maxAmount}`"></span>
                                </div>
                                <div class="other-text">
                                    <span class="left">Tenure:</span>                                    
                                    <span class="right">&nbsp;91~180 days</span>
                                </div>                                
                            </div>                               
                        </div>
                       
                    </div>
                    <h2 class="element-title">
                        <div class="et-inner">
                            <img :src="element.logo" alt="">
                            <span v-text="element.name"></span>
                        </div>
                        <div class="title-apply" v-text="element.fullButtonName"></div>
                    </h2>
                </div>
            </div>                        
        </div>                
        <div class="intro-dialog-wrapper"  v-show="introDialogState" @click="closeDialog">
            <div class="intro-dialog">
                <a href="javascript:void(0);" class="icon icon-close" @click="closeDialog"></a>
                <div class="indialog-content" @click.stop="ppp" >
                    <div class="intro-element" v-for="(element,ind) in activeLock" :key="ind">
                        <div class="intro-caption" v-html="element.title"></div>
                        <div class="intro-content" v-html="element.content"></div>
                    </div>                    
                </div>
            </div>
        </div>
        <div class="big-dialog-wrapper" v-show="bigDialogState">
            <div class="big-dialog-inner">
                <a href="javascript:void(0);" class="icon icon-close" @click="closeBigDialog"></a>
                <div class="big-dialog">                
                    <div class="big-content">
                    <div class="big-element cooper">
                        <h2 class="be-title"><div class='be-title-left'><i class="icon icon-copper-lock"></i><span class="title-text">Copper Lock</span></div><a href="javascript:void(0);" class="btn-close" @click="closeBigDialog">APPLY NOW</a></h2>
                        <div class="be-content">
                            <div class="bec-element"><span class="left">Unlocking condition:</span><span class="right">Successfully repay a loan on time</span></div>
                            <div class="bec-element"><span class="left">Discount scheme:</span><span class="right">Maximum service fee reduction of 5%</span></div>
                        </div>
                    </div>
                    <div class="big-element sliver">
                        <h2 class="be-title"><div class='be-title-left'><i class="icon icon-siliver-lock"></i><span class="title-text">Silver Lock</span></div><a href="javascript:void(0);" class="btn-close" @click="closeBigDialog">APPLY NOW</a></h2>
                        <div class="be-content">
                            <div class="bec-element"><span class="left">Unlocking condition:</span><span class="right">Successfully repay two loan on time</span></div>
                            <div class="bec-element"><span class="left">Discount scheme:</span><span class="right">Maximum service fee reduction of 9%</span></div>
                        </div>
                    </div>
                    <div class="big-element gold">
                        <h2 class="be-title"><div class='be-title-left'><i class="icon icon-gold-lock"></i><span class="title-text">Gold Lock</span></div><a href="javascript:void(0);" class="btn-close" @click="closeBigDialog">APPLY NOW</a></h2>
                        <div class="be-content">
                            <div class="bec-element"><span class="left">Unlocking condition:</span><span class="right">Successfully repay four loan on time</span></div>
                            <div class="bec-element"><span class="left">Discount scheme:</span><span class="right">Maximum service fee reduction of 13%</span></div>
                        </div>
                    </div>                    
                    </div>
                    
                </div>
            </div>            
        </div>
        
    </div>
</template>
<style lang="less" scoped>
    @import "~assets/less/icon.less";
    .big-dialog-wrapper{
        position:fixed;
        top:0;
        bottom:0;
        left:0;
        right:0;
        width: 100%;
        height:100%;
        background:RGBA(255, 50, 163, 1);
        background-size: 100% 100%;
        overflow: auto;
        z-index: 999;  
        div.big-dialog-inner{
            width: 100%;
            min-height: 1509px;
            background:url("../../../assets/images/callback/dbg.png") no-repeat;
            background-size: contain;
            position: absolute;
            top:0;
            left:0;
            padding-bottom: 50px;            
        }      
        .icon-close{
            position: absolute;
            top:40px;
            right:40px;
        }
        .big-dialog{
            background:#fff;
            width: 616px;
            // height: 876px;
            padding:25px 35px;
            margin:220px auto 0 auto;
            border-radius: 20px;
            .bec-element{                
                line-height: 1.5;
                .left{                    
                    color:#333;
                    font-size: 28px;
                    font-weight: 700;
                }
                .right{
                    color:#333;
                    font-size: 28px;
                }
            }
            .big-element{
                margin-bottom: 50px;
                &.cooper{
                    .be-content{
                        background:rgba(250, 177, 140, 0.15);
                        padding:20px;
                        width: 566px;
                        margin-top: 30px;
                        border-radius: 20px;
                        .bec-element{
                            &::nth-child(2){
                                .right{
                                    color:rgba(233, 144, 107, 1)
                                }
                            }
                        }
                    }
                    
                }
                &.siliver{
                    .be-content{
                        background:RGBA(248, 249, 255, 1);
                        padding:20px;
                        width: 566px;
                        .bec-element{
                            &::nth-child(2){
                                .right{
                                    color:RGBA(125, 133, 198, 1)
                                }
                            }
                        }
                    }
                    
                }
                &.gold{
                    .be-content{
                        background:RGBA(255, 248, 238, 1);
                        padding:20px;
                        width: 566px;
                        .bec-element{
                            &::nth-child(2){
                                .right{
                                    color:RGBA(241, 138, 25, 1)
                                }
                            }
                        }
                    }
                    
                }
                .be-title{
                    display: flex;
                    justify-content: space-around;
                    color:#333;
                    margin-bottom: 30px;
                    .be-title-left{
                        display:flex;
                        justify-content: start;
                    }
                    .title-text{
                        display: block;
                        font-size: 34px;
                        display: flex;
                        justify-content: start;
                        align-items: center;
                        margin-left: 15px;
                        font-weight: 700;
                    }
                    .btn-close{
                        display: block;
                        width:190px;
                        height:60px;
                        border-radius: 10px;
                        font-size: 24px;
                        background:#5febf3;
                        color:#fff;
                        text-align: center;
                        line-height: 60px;
                        margin-left: 100px;
                        &:active{
                            transform: scale(1.1,1.1);
                        }
                    }
                    .icon{
                        margin:0
                    }
                    .icon-gold-lock{
                        width: 40px;
                        height: 50px;
                        background:url("../../../assets/images/callback/icon-gold.png") no-repeat;
                        background-size:100% 100%;
                    }
                    .icon-copper-lock{
                        width: 40px;
                        height: 50px;
                        background:url("../../../assets/images/callback/icon-copper.png") no-repeat;
                        background-size:100% 100%;
                    }
                    .icon-siliver-lock{
                        width: 40px;
                        height: 50px;
                        background:url("../../../assets/images/callback/icon-siliver.png") no-repeat;
                        background-size:100% 100%;
                    }
                }
            }
        }
    }
    .intro-dialog-wrapper{
        position:fixed;
        top:0;
        bottom:0;
        left:0;
        right:0;
        width: 100%;
        height: 100%;
        background:rgba(0,0,0,0.6);
        z-index: 999;
        .intro-dialog{
            width: 600px;
            height: 320px;
            position: absolute;
            background:#fff;
            border-radius: 30px;
            top:50%;
            left:50%;
            transform: translate(-50%,-50%);
            padding-top: 30px;
            .icon-close{
                position: absolute;
                top:10px;
                right:20px;
            }
            .indialog-content{
                padding:30px;
                .intro-element{
                    margin-bottom: 30px;
                    .intro-caption{
                        color:#999;
                        font-size: 30px;
                        margin-bottom: 30px;
                    }
                    .intro-content{
                        color:#333;                        
                        font-size: 30px;
                        line-height: 1.5;
                        word-break: break-all;
                    }
                }
            }
        }
    }
    .top{
        padding:20px 20px;
        .banner{
            width:720px;
            margin:0 auto 30px auto;
            a {
                display: block;
                border-radius: 20px;
                overflow: hidden;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
        }
        .product-list{
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            .list-element{
                width: 650px;
                border:10px solid #5febf3;
                background:#fff;
                padding:30px;                
                overflow:hidden;                
                background-size:100% 100%;
                position: relative;
                // box-shadow: 0px 22px 50px 0px rgba(0,0,0,0.0800);
                margin-bottom: 50px;
                border-radius: 20px;
                .list-element-cover{
                    position: absolute;
                    top:0;
                    bottom:0;
                    left:0;
                    right:0;
                    width: 100%;
                    height: 100%;
                    background:rgba(0,0,0,0.6);                    
                    &:active{
                        transform: scale(1.1,1.1);
                    }
                    &:visited{
                        transform: scale(1.1,1.1);
                    }
                    &:hover{
                        transform: scale(1.1,1.1);
                    }
                    .list-element-cover-container{
                        width: 120px;
                        height: 120px;
                        position: absolute;
                        top:50%;
                        left:50%;
                        transform: translate(-50%,-50%);
                        
                        img{    
                            width: 100%;
                            height: 100%;
                        }
                    }
                }
                .element-title{
                    padding:0 50px 0 50px;
                    background:#333;
                    border-radius: 85px;
                    width: 500px;
                    height:85px;
                    line-height: 65px;
                    margin:0 auto;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;                    
                    .et-inner{
                        display: flex;
                        align-items: center;
                        justify-content: start;                    
                        img{
                            width: 48px;
                            height: 48px;
                            margin-right: 20px;
                        }
                        span{
                            color:#fff;
                            font-size: 30px;
                            // overflow:hidden;
                            white-space: nowrap;
                        }
                    }
                    .title-apply{                        
                        height: 68px;
                        font-size: 30px;
                        text-align: center;
                        color:#FF6AB7;
                        background:#333;   
                        font-weight: 700;                     
                    }
                    
                }
                .info{
                    padding: 0 30px 20px 30px;
                    .caption{
                        font-size: 32px;
                        color:#8A82A1;
                        text-align:center;
                        margin-bottom: 30px;
                    }
                    .amount{
                        font-size: 96px;
                        color:#000;
                        text-align: center;
                        font-weight: 700;
                    }
                    .other-info{
                        overflow: hidden;                        
                        .oi-left{                            
                            width: 100%;
                            .left-text{
                                text-align: center;
                                font-size: 30px;
                                .left{                                    
                                    font-size: 26px;
                                    display: inline-block;
                                    color:#160544;                                    
                                }
                                .right{
                                    margin-top: 10px;
                                    color:#A59BB3;
                                    font-size: 30px;
                                    display: inline-block;
                                    &.strong{
                                        font-size: 60px;
                                        font-weight: 700;
                                        color:#333;
                                    }                                    
                                }
                            }
                        }
                        .other-text{
                            display: flex;
                            justify-content: space-between;
                            margin: 20px;
                            .left{                                    
                                font-size: 28px;
                                color:#160544;                                    
                            }
                            .right{
                                
                                color:#A59BB3;
                                font-size: 28px;
                                &.strong{
                                    font-size: 50px;
                                    color:#333;
                                }                                    
                            }
                        }                                                
                    }
                    .oi-right{
                        margin-top: 15px;
                        .btn-apply{
                            display:block;
                            width: 170px;
                            height: 60px;
                            line-height: 60px;
                            color:#fff;
                            font-size: 26px;
                            text-align:center;
                            background:#A59BB3;
                            border-radius: 6px;
                            margin:0 auto;
                            &:active{
                                transform: scale(1.1,1.1);
                            }
                            &.active{
                                background:#5febf3
                            }
                        }
                    }
                }
            }
        }
    }
</style>
<script>
import { getCurrentInstance,ref } from 'vue';
import {useRouter} from 'vue-router'
import { useStore } from 'vuex'
import { getUserAuthState,prechech } from '@api/index'
import { useLoading } from 'vue-loading-overlay'
export default {    
    props:{
        imgList:{
            type:Array,
            default:()=>{}
        },
        money: String ,
        logined: String,
        list: {
            type:Array,
            default:()=>{}
        },
        ulist:{
            type:Array,
            default:()=>{}
        }
    },
    setup() {
        const router = useRouter()
        const store = useStore()  
        const proxy  = getCurrentInstance().proxy
        // const route = router.currentRoute
        const ppp = () => {}
        const intro = ["","",
            [
                {
                    "title":"Unlocking condition:",
                    "content":"Successfully repay <strong style='color:red;font-size:0.45rem'>1</strong> loan on time"
                },{
                    "title":"Discount scheme:",
                    "content":"Maximum service fee reduction of <strong style='color:red;font-size:0.45rem'>5%</strong>"
                }
                
            ],
            [
                {
                    "title":"Unlocking condition:",
                    "content":"Successfully repay <strong style='color:red;font-size:0.45rem'>1</strong> loans on time"
                },{
                    "title":"Discount scheme:",
                    "content":"Maximum service fee reduction of <strong style='color:red;font-size:0.45rem'>9%</strong>"
                }
                
            ],
            [
                {
                    "title":"Unlocking condition:",
                    "content":"Successfully repay <strong style='color:red;font-size:0.45rem'>4</strong> loans on time"
                },{
                    "title":"Discount scheme:",
                    "content":"Maximum service fee reduction of <strong style='color:red;font-size:0.45rem'>13%</strong>"
                }
                
            ],
            [
                {
                    "title":"Unlocking condition:",
                    "content":"Successfully repay <strong style='color:red;font-size:0.45rem'>5</strong> loans on time"
                },{
                    "title":"Discount scheme:",
                    "content":"Maximum service fee reduction of <strong style='color:red;font-size:0.45rem'>14%</strong>"
                }                
            ],
            [
                {
                    "title":"Unlocking condition:",
                    "content":"Successfully repay <strong style='color:red;font-size:0.45rem'>5</strong> loans on time"
                },{
                    "title":"Discount scheme:",
                    "content":"Maximum service fee reduction of <strong style='color:red;font-size:0.45rem'>14%</strong>"
                }                
            ]
        ]
        const loading = useLoading()
        let activeLock = ref([])
        let introDialogState = ref(false)
        let bigDialogState = ref(false)
        const closeBigDialog = () => {
            bigDialogState.value = false
        }
        const showBigDialog = () => {
            bigDialogState.value = true
        }
        const undway_apply = (id,orderState) => {
            if(['1'].indexOf(orderState) != -1 ) {
                router.push({
                    path:`/orders/${id}/audit`
                })
            } else if ( orderState == '2' ) {
                router.push({
                    path:`/orders/${id}/confirm`
                })                
            } else if (orderState == '6' || orderState == '8') {
                router.push({
                    path:`/orders/${id}/detail`
                })
            } else {
                router.push({
                    path:'/order'
                })
            }    
            
        }
        const showDialog = (nums) => {
            activeLock.value = intro[nums]
            introDialogState.value = true
        }
        const closeDialog = () => {            
            introDialogState.value = false
        }
        

        const before_apply = async (element) => {               
            store.dispatch("bury", {"eventId":"home_page_app_button_click"})
            let loader = loading.show({
                container: null
            })
            const dd = await prechech({
                productId: element.id
            })
            
            if(dd.code == 0) {
                if(dd.data.orderStatus == 0) {
                    loader.hide()
                    router.replace({
                        "path":`/product/${element.id}/denied`,
                        "query":{
                            "day":dd.data.rejectStatusVO.day,
                            "hour":dd.data.rejectStatusVO.hour
                        }
                    })
                    return
                } 
                if(dd.data.orderStatus == 2) {
                    loader.hide()
                    router.replace({
                        "path":`/order`,                        
                    })
                    return
                }                
            } else {
                loader.hide()
            }
            
            const dd2 = await getUserAuthState()
            if(dd2.code == 0) {                
                if(dd2.data.state == 2) {
                    loader.hide()
                    router.push({
                        "path":`/promotion/before`
                    })                    
                    return 
                } else if(dd2.data.state == 1) {
                    loader.hide()
                    proxy.$toast.show("Quota is Full")
                    return
                } else {
                    proxy.$toast.show("This mobile account in the BenevoLend product has no orders.Please use the correct mobile number to log in.")
                }
            }  else {
                loader.hide()
                proxy.$toast.show("This mobile account in the BenevoLend product has no orders.Please use the correct mobile number to log in.")
            }     
        }
            
        return {
            before_apply,undway_apply,showDialog,closeDialog,activeLock, introDialogState,bigDialogState,closeBigDialog,showBigDialog,ppp
        }        
    }        
}
</script>